import loadable from "@loadable/component"
import type { RouteObject } from "react-router-dom"
import { APP_ROUTES } from "~/shared/constants/routes"
const DriverMessagesPage=loadable(()=>import("./pages/DriverMessagesPage"),{fallback:<></>})
export const driverMessageRoutes:RouteObject[]=[{path:APP_ROUTES.driverMessages,element:<DriverMessagesPage/>}]
